import { Center, Loader } from '@mantine/core';
import { useApi } from 'api/api-context';
import { parseDeviceQrPathname } from 'features/device-qr/parse-device-qr';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EDIT_DEVICE_PAGE_PATH, NOT_FOUND_PAGE_PATH } from 'routes/paths';

/** Resolves the raw QR path without React Router decoding the ID. */
export default function DeviceQrRedirectPage() {
  const { getAction } = useApi();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const qrId = parseDeviceQrPathname(location.pathname);

    if (!qrId) {
      navigate(NOT_FOUND_PAGE_PATH.original, { replace: true });
      return;
    }

    getAction('DeviceQrResolve')({ query: { qrId } })
      .then(({ deviceId }) => navigate(EDIT_DEVICE_PAGE_PATH.insert({ deviceId }), { replace: true }))
      .catch(() => navigate(NOT_FOUND_PAGE_PATH.original, { replace: true }));
  }, [getAction, location.pathname, navigate]);

  return (
    <Center h="100vh">
      <Loader size="lg" />
    </Center>
  );
}
